/**
 * jQuery 4 removed $.type() - polyfill for slick-carousel and other
 * dependencies that still use it. Import this before any such libraries.
 */
import $ from 'jquery';

if (typeof $.type !== 'function') {
  $.type = function (obj) {
    if (obj == null) {
      return String(obj);
    }
    return typeof obj === 'object' || typeof obj === 'function'
      ? Object.prototype.toString.call(obj).slice(8, -1).toLowerCase()
      : typeof obj;
  };
}
